"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSDataPassHistoryComponent = void 0;
const _ = require("underscore");
const orderhistory_service_1 = require("../../shared/services/orderhistory.service");
const token_service_1 = require("../../shared/services/token.service");
var paymentMethod;
(function (paymentMethod) {
    paymentMethod["CREDIT_CARD"] = "Credit Card";
    paymentMethod["DEBIT_CARD"] = "Debit Card";
    paymentMethod["GIFT_CARD"] = "Gift Card";
    paymentMethod["BILL_TO_ACCOUNT"] = "Bill To Account";
    paymentMethod["CASH"] = "Cash";
    paymentMethod["CHECK"] = "Check";
    paymentMethod["MIGRATION"] = "Migration";
    paymentMethod["EFT"] = "EFT";
    paymentMethod["MONEY_ORDER"] = "Money Order";
})(paymentMethod || (paymentMethod = {}));
class CSDataPassHistoryComponent {
    constructor(orderHistory, tokenService) {
        this.orderHistory = orderHistory;
        this.tokenService = tokenService;
        this.loader = false;
        this.paymentMethod = paymentMethod;
        this.rowCount = 5;
        this.hideShowMore = true;
        this.isShowMore = false;
    }
    ngOnInit() {
        this.gtDataPassPurchaseOrderHistory();
    }
    gtDataPassPurchaseOrderHistory() {
        this.loader = true;
        this.orderHistory.gtDataPassPurchaseOrderHistory()
            .subscribe((orderHistoryDetail) => {
            this.loader = false;
            if (!orderHistoryDetail) {
                this.noOrder = true;
            }
            else {
                this.details = orderHistoryDetail;
                this.details.datapassPurchaseHistory = _.sortBy(this.details.datapassPurchaseHistory, 'dataPassPurchaseDate').reverse();
                this.dataCount = orderHistoryDetail === null || orderHistoryDetail === void 0 ? void 0 : orderHistoryDetail.datapassPurchaseHistory.length;
                this.noOrder = false;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    showMore() {
        if (!this.isShowMore) {
            this.rowCount = this.dataCount;
            this.hideShowMore = false;
            this.isShowMore = true;
        }
        else {
            this.rowCount = 5;
            this.hideShowMore = true;
            this.isShowMore = false;
        }
    }
    showDetails(order) {
        this.order = order;
        this.dataPassName = this.order.dataPassDisplayName;
        this.mdn = this.order.mobileNumber;
        if (this.order.orderId) {
            this.getOrderDetails(this.order.orderId);
        }
    }
    getOrderDetails(orderId) {
        this.orderDetails = null;
        this.loader = true;
        this.orderHistory.getDataPassOrderHistoryDetails(orderId)
            .subscribe((orderHistoryDetail) => {
            this.loader = false;
            if (orderHistoryDetail) {
                this.orderDetails = orderHistoryDetail;
            }
            setTimeout(() => {
                this.downloadInvoice();
            }, 1000);
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    downloadInvoice() {
        const invoiceBody = document.getElementById('orderDetailsInvoice').innerHTML;
        // eslint-disable-next-line max-len
        const invoiceWindow = window.open('', 'width=600,height=700,top=0,left=0,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        invoiceWindow.focus();
        // eslint-disable-next-line max-len
        invoiceWindow.document.write('<html><head><title>Data Pass Order Details</title><link rel="stylesheet" type="text/css" href="/resources/css/compiled-css/mma/mma.css"/></head><body onload="window.print()">' + invoiceBody + '</html>');
        invoiceWindow.document.close();
    }
}
exports.CSDataPassHistoryComponent = CSDataPassHistoryComponent;
//# sourceMappingURL=datapasshistory.component.js.map